import React, { useEffect } from 'react'

import { Route, Switch } from 'react-router-dom'

import { observer } from 'mobx-react-lite'

import { Layout } from 'common/components/Layout'
import { Loading } from 'common/components/Loading'
import { useQuery } from 'common/hooks/use-query'
import { useReloadIdleUser } from 'common/hooks/use-reload-idle-user'

import { MainMenu } from 'vendor/components/MainMenu'
import { useVendorStores } from 'vendor/hooks/use-stores'
import { VendorOrderMaterialPageV2 } from 'vendor/pages/Private/@v2/OrderMaterials/order_materials_page'
import { VendorOrdersPageV2 } from 'vendor/pages/Private/@v2/Orders/orders_page'
import CustomersPage from 'vendor/pages/Private/Customers'
import DashboardPage from 'vendor/pages/Private/Dashboard'
import OrderDetail from 'vendor/pages/Private/OrderDetail/order_detail'
import VendorUserSettings from 'vendor/pages/Private/UserSettings'
import VendorSettings from 'vendor/pages/Private/VendorSettings'

const Private = observer(() => {
  useReloadIdleUser()

  const { userStore, notificationStore } = useVendorStores()

  const { isLoading } = useQuery(userStore.showUser)

  useEffect(() => {
    if (userStore.currentUser?.id) {
      notificationStore.subscribe(userStore.currentUser?.id)
      notificationStore.getIndexNotifications().then(() => notificationStore.updateCounters())
    }
  }, [userStore.currentUser])

  if (isLoading) {
    return <Loading />
  }

  if (!userStore.currentUser) {
    return
  }

  return (
    <Layout header={<MainMenu />}>
      <Switch>
        <Route path="/vendor/orders">
          <VendorOrdersPageV2 />
        </Route>
        <Route path="/vendor/order/:id">
          <OrderDetail />
        </Route>
        <Route path="/vendor/user_settings">
          <VendorUserSettings />
        </Route>

        {userStore.canUseOrderMaterials && (
          <Route path="/vendor/order_materials">
            <VendorOrderMaterialPageV2 />
          </Route>
        )}
        {userStore.canManageSettings && (
          <Route path="/vendor/settings">
            <VendorSettings />
          </Route>
        )}

        {userStore.canUseWatchersByCustomer && (
          <Route path="/vendor/customers">
            <CustomersPage />
          </Route>
        )}

        {userStore.canUseDashboard && (
          <Route path="/vendor/dashboard">
            <DashboardPage />
          </Route>
        )}
      </Switch>
    </Layout>
  )
})

export default Private
